import { ref, push, query, orderByChild, limitToLast, get } from 'firebase/database';
import { signInAnonymously } from 'firebase/auth';
import { database, auth } from './firebase-config';

export interface ScoreEntry {
  playerName: string;
  score: number;
  timestamp: number;
}

export const ensureAuth = async (): Promise<void> => {
  if (!auth.currentUser) {
    await signInAnonymously(auth);
  }
};

export const saveScore = async (playerName: string, score: number): Promise<void> => {
  if (typeof playerName !== 'string' || playerName.length > 20) {
    throw new Error('Invalid player name');
  }

  if (typeof score !== 'number' || score < 0 || score > 1000) {
    throw new Error('Invalid score');
  }

  await ensureAuth();

  const scoresRef = ref(database, 'scores');
  const scoreData: ScoreEntry = {
    playerName,
    score,
    timestamp: Date.now()
  };

  await push(scoresRef, scoreData);
};

export const getTopScores = async (limit: number = 7): Promise<ScoreEntry[]> => {
  try {
    const scoresRef = ref(database, 'scores');
    const topScoresQuery = query(
      scoresRef,
      orderByChild('score'),
      limitToLast(limit)
    );

    const snapshot = await get(topScoresQuery);
    if (!snapshot.exists()) {
      return [];
    }

    const scores: ScoreEntry[] = [];
    snapshot.forEach((childSnapshot) => {
      const data = childSnapshot.val();
      if (data && typeof data.score === 'number') {
        scores.push({
          playerName: data.playerName || "Unknown",
          score: data.score,
          timestamp: data.timestamp || Date.now()
        });
      }
    });

    return scores.sort((a, b) => b.score - a.score);
  } catch (error) {
    console.error("Error fetching scores:", error);
    return [];
  }
};
